import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import banner from "../../../components/banner";
import news from "../../../components/news";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import maskPDF from "../../../components/maskPDF";
import customerTalk from "../../../components/customerTalk";
import './caseCampus.less'
export default {
    name: "caseCampus",
    data() {
        return {
            black:{
                title: '收款小精灵通过校园专属硬件设备、结合在线储值、外卖商城在线购物、会员分层和管理，打通原有实体卡，实现校园一卡通，打造智慧校园',
                info: '从校园超市、食堂、团购外卖、购物，通过一张电子会员卡可以实现整个校园的吃喝玩乐购一体化解决方案。为学校带来移动化、数字化的新体验。'
            },
            info: [
                {
                    title1: '从线下到线上',
                    title2: '打造校园一卡通',
                    pic: 'img/caseCampus/info1.png',
                    info: [
                        '微信、支付宝、校园实体IC卡、电子会员卡、小程序、全部实现一卡通用',
                        '线下：超市、食堂校园门店；线上：校园外卖、商城小程序，全场景一卡同通用',
                        '总部统一管理、统一运营：整个校园流量全部可归集、可标签、可筛选、可触达',
                        '门店互相独立结算'
                    ],
                    block: ''
                },
                {
                    title1: '优惠费率',
                    title2: '支持多种支付方式',
                    pic: 'img/caseCampus/info2.png',
                    info: [
                        '校园特殊行业费率，支付成本低',
                        '支持微信、支付宝、刷脸支付、API接口、小程序等多种支付方式接入',
                        '支持统一收款，门店分账；多门店直接到账；储值单独分账等多种结算清算方式'
                    ],
                    block: 'swap'
                },
                {
                    title1: '专属设备',
                    title2: '支持多种付款场景',
                    pic: 'img/caseCampus/info3.png',
                    info: [
                        '支持收银系统、插件、小白盒、悬挂式消费机，等多种设备适配多种场景',
                        '消费机可免费申请，防水放油，同时支付移动支付、IC实体卡、电子卡、刷脸支付'
                    ],
                    block: ''
                },
                {
                    title1: '小程序商城',
                    title2: '用流量快速做增长',
                    pic: 'img/caseCampus/info4.png',
                    info: [
                        '外卖点餐、商城购物、活动赛事、在线直播、拼团秒杀，通过小程序直接在线流量变现',
                        '推荐开卡、裂变分销、精准触达、礼包营销结合电子会员卡可直接在线购买和储值，数据增长看得见'
                    ],
                    block: 'swap'
                }
            ],
            rollList: [
                {
                    src: "/img/caseCampus/roll1.png",
                    size: 3,
                },
                {
                    src: "/img/caseCampus/roll2.png",
                    size: 2,
                },
                {
                    src: "/img/caseCampus/roll3.png",
                    size: 4,
                },
                {
                    src: "/img/caseCampus/roll4.png",
                    size: 3,
                },
                {
                    src: "/img/caseCampus/roll5.png",
                    size: 4,
                },
                {
                    src: "/img/caseCampus/roll6.png",
                    size: 2,
                }
            ],
            campus: {
                title: '校园场景优质案例',
                more: '',
                num: 3,
                info: [
                    {
                        pic: "/img/caseCampus/campus1.png",
                        title: "拿下保定16所高校，小精灵让20万学子安心就餐！",
                        txt: "河北大学、华北电力大学、河北农业大学...保定16所高校，全部合作小精灵,免费申请微信校园专属消费机、云喇叭等硬件，结合电子会员卡，移动支付，在线储值，让20万学子更就餐更轻松！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseCampus/campus2.png",
                        title: "一个小程序满足高效食堂的所有需求，小精灵与【西南民大】高校餐厅的故事",
                        txt: "语音码牌+商户小程序，可以支持微信、支付宝、会员卡收款，码牌和小程序都会播报，收款清晰。老板运用小程序对账，结算清晰明确。",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseCampus/campus3.png",
                        title: "一个小程序，让【广州海洋大学】的复购率增长75%",
                        txt: "2018年12月，海洋大学超市上线了电子会员，3秒开卡，学生利用积分兑换商品和券。不到半年时间，开卡13000+，占总人数的40%。",
                        pdf: "",
                    },
                ]
            },
            customerTalk1: {
                bg: '#dd5c3f',
                pic: 'img/caseCampus/person1.png',
                info: '“作为一家餐饮公司，我们的角色处在商户和高校之间。高校想让我们统一所有收款方式，数据清晰。门店想缩短一个月账期。遇到小精灵后消费机可以解决移动支付、刷脸支付、IC卡支付，极为方便；商户消费可以第二天就到账也没有了财务压力，学生可以会员支付，在线储值极为方便，一举三得！”',
                person: '— 余先生，河北大学校园餐厅管理公司， 负责人'
            }
        }
    },
    components: {
        skeleton,
        banner,
        news,
        customerTalk,
        pay,
        QRCode,
        maskPDF,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
